export default __webpack_public_path__ + "static/media/page-not-found.4754a9d7.svg";